var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V2.33893C0 2.92135 0.286591 3.46679 0.76732 3.7996L4.73333 6.80415V14.2L7.1 11.8333V6.80415L11.066 3.7996C11.5467 3.46679 11.8333 2.92134 11.8333 2.33893V0H0ZM1.18333 1.18333H10.65V2.33893C10.65 2.53307 10.5529 2.71335 10.3911 2.82428L10.3819 2.82891L6.30957 5.91668H5.52376L1.45143 2.82892L1.44219 2.8243C1.2804 2.71336 1.18333 2.53309 1.18333 2.33894V1.18333Z",
    fill: "#586377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltro);
export default __webpack_public_path__ + "static/media/filtro.e7ce80fca234fbd6112ed63434635a1e.svg";
export { ForwardRef as ReactComponent };